import { FunctionComponent } from 'react';
import { types as commonTypes, hooks as commonHooks } from '@sitebuilder/common';

const CONTENTS_PLACEHOLDER_ID = 'children';

const DataProviderWebProfile: FunctionComponent<
    React.PropsWithChildren<commonTypes.WidgetInstanceProps>
> = (props) => {
    const { widgetInstanceId, data } = props;
    const { Placeholder } = commonHooks.useAppContext();

    return (
        <div id="web-data-provider">
            {widgetInstanceId && (
                <Placeholder
                    data={data}
                    contentPlaceHolderId={CONTENTS_PLACEHOLDER_ID}
                    parentWidgetInstanceId={widgetInstanceId}
                />
            )}
        </div>
    );
};

export default DataProviderWebProfile;
